import React, { useEffect, useState } from "react";
import { NavBar } from "./nav-bar";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../app/service/admin.service";
import { toast } from "react-toastify";

const AllDomainHome = () => {
  const navigate = useNavigate();
  const [courseData, setCourseData] = useState<any>([]);
  const [filterData, setFilterData] = useState<any>([]);
  const [originalCourseData, setOriginalCourseData] = useState<any[]>([]);

  useEffect(() => {
    getCoursesList();
    getRegisters();
  }, []);

  const getRegisters = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
      type: "registerNow",
    };
    AdminService.allfilterAccessList(data).then((res: any) => {
      if (res.status === "Success") {
        setFilterData(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const getCoursesList = () => {
    const data = {
      search: "",
      start: 1,
      count: 10,
    };
    AdminService.getCourseList(data).then((res: any) => {
      if (res.status === "Success") {
        setCourseData(res.data);
        setOriginalCourseData(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const handleClick = (domain: any) => {
    navigate(`/program-details`, { state: domain });
  };
  const handleFilteredData = (item: any) => {
    const courseNames = filterData
      .filter((f: any) => f.btechCourse?.toLowerCase() === item.btechCourse?.toLowerCase())
      .map((f: any) => f.course?.toLowerCase());
  
    const filteredData = originalCourseData.filter((course: any) =>
      courseNames.includes(course.courseName?.toLowerCase())
    );
  
    setCourseData(filteredData);
  };
  
  

  const uniqueBtechItems = Array.from(
    new Map(filterData.map((item: any) => [item.btechCourse, item])).values()
  );
  



  return (
    <div
      className="container-fluid scroll-bar-width-none primary-bg text-white pt-5"
      style={{ backgroundColor: "#1d130f", color: "white" }}
    >
      <div className="row m-5">
        <div className="col-md-12">
          <NavBar />
        </div>
        <div className="border-white my-5 pb-5 text-center pt-3">
          <h4>Build future-ready skills with Eduexpose</h4>
          <div className="text-center mt-3 mb-5 d-flex justify-content-center flex-wrap gap-3">
            <div
              className="px-3 py-2 border rounded bg-light text-dark"
              style={{ cursor: "pointer" }}
              onClick={() => setCourseData(originalCourseData)}
            >
              All
            </div>

            {uniqueBtechItems.map((item: any, index: number) => (
              <div
                key={index}
                className="px-3 py-2 border rounded bg-light text-dark"
                style={{ cursor: "pointer" }}
                onClick={() => handleFilteredData(item)}
              >
                {item.btechCourse}
              </div>
            ))}
          </div>

          <div className="row mb-3 pt-5">
            {courseData.map((domain: any, index: number) => (
              <div
                key={index}
                className="col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-3 alldomain-hover"
              >
                <div key={index} className="card primary-bg text-white mx-md-2">
                  <div className="alldomain-img-hover">
                    <img
                      src={domain.image}
                      className="card-img-top trending-domain-card-image"
                      alt="..."
                    />
                  </div>

                  <div className="card-content text-start">
                    <div className="tags">
                      <div className="tag">Development</div>
                      <div className="tag my-0">Intermediate</div>
                      <div className="seat">
                        <i className="fa-regular fa-user"></i>{" "}
                        {domain?.soldSeats}/{domain?.totalSeats} Seats
                      </div>
                    </div>
                    <h3 className="card-title">{domain.courseName}</h3>
                    <p className="card-text">{domain.description}</p>
                    <div className="mt-3">
                      <button
                        className="btn-learn-more"
                        onClick={() => handleClick(domain)}
                      >
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllDomainHome;
